<template>
  <div class="sign_up_box">
    <div class="input_box email">
      <label for="signUpEmail">
        <i class="xi-mail-o" />
      </label>
      <input
        id="signUpEmail" type="text"
        placeholder="EMAIL" v-model="signupForm.email"
        @input="inputValueAni"
        @blur="errorSignupVerification"
      >
    </div>
    <p
      v-if="qualificationFunction('showEmailErrorMessage')"
      class="error_message"
    >
      {{ errorMessage.email }}
    </p>
    <div class="input_box">
      <label for="signUpName">
        <i class="xi-user" />
      </label>
      <input
        id="signUpName" type="text"
        placeholder="NAME" v-model="signupForm.name"
        @input="inputValueAni"
      >
    </div>
    <div class="input_box">
      <label for="signUpPassword">
        <i class="xi-lock-o" />
      </label>
      <input
        id="signUpPassword" type="password"
        placeholder="PASSWORD" v-model="signupForm.password"
        @input="inputValueAni"
      >
    </div>
    <div class="input_box">
      <label for="signUpConfirmPassword">
        <i class="xi-lock-o" />
      </label>
      <input
        id="signUpConfirmPassword" type="password"
        placeholder="CONFIRM PASSWORD" v-model="confirmPassword"
        @input="inputValueAni"
        @blur="errorSignupVerification"
      >
    </div>
    <p
      v-if="qualificationFunction('showConfirmErrorMessage')"
      class="error_message"
    >
      {{ qualificationFunction("showConfirmErrorMessage") ? errorMessage.confirmPassword : ""
      }}
    </p>
    <div class="input_box">
      <label for="signUpNickName">
        <i class="xi-user-o" />
      </label>
      <input
        id="signUpNickName" type="text"
        placeholder="NICKNAME" v-model="signupForm.nickname"
        @input="inputValueAni"
      >
    </div>
    <button
      class="sign_up_btn" type="button"
      :disabled="qualificationFunction('disabledSignup')"
      @click="submitSignupFunction"
    >
      Sign up
    </button>
    <div class="sign_up_cancel_btn">
      <button
        type="button"
        :disabled="disabledQualification()"
        @click="showSignupToggle"
      >
        <i class="xi-angle-left-min" />
        Cancel
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';

import useCommonStore from '@/store/storeCommon';
import useMemberStore from '@/store/storeMember';

const { inputValueAni, showModal, showSignupToggle, disabledQualification, modalContents } = useCommonStore();
const { isLoading, isMainLogo, isSatelliteInfo } = storeToRefs(useCommonStore());
const { accessSignup, errorMessage, emailRegex, signupForm } = useMemberStore();
const { confirmPassword } = storeToRefs(useMemberStore());

/**
 *  회원가입을 실행합니다.
 */
const submitSignupFunction = async (): Promise<void> => {
  try {
    isLoading.value = true;

    const response = await accessSignup();

    if (response) {
      showModal.isSuccess = true;
      confirmPassword.value = '';
      errorMessage.confirmPassword = '';

      isMainLogo.value = true;
      isSatelliteInfo.value = false;

      Object.assign(signupForm, {
        email: '',
        name: '',
        password: '',
        nickname: '',
      });
      Object.assign(modalContents, {
        title: 'Welcome!',
        description: '회원가입이 성공하였습니다.\n로그인해 주세요.',
      });
    }
  } catch (e) {
    console.log(e);
  } finally {
    isLoading.value = false;
  }
};

/**
 *  blur 시, 이메일 유효성 검사 & 비밀번호 확인하고 에러 메세지를 표시합니다.
 */
const errorSignupVerification = (): void => {
  if (!emailRegex.test(signupForm.email) && signupForm.email) {
    errorMessage.email = '올바르지 못한 이메일 형식입니다.';
  }
  if (emailRegex.test(signupForm.email) && signupForm.email && (errorMessage.email !== '이미 등록된 이메일입니다.')) {
    errorMessage.email = '';
  }
  if (confirmPassword.value !== signupForm.password) {
    errorMessage.confirmPassword = '비밀번호가 다릅니다.';
  }
  if (!confirmPassword.value) {
    errorMessage.confirmPassword = '';
  }
};

/**
 * 조건별 함수
 */
const qualificationFunction = (qualification: string): boolean => {
  switch (qualification) {
    case 'showEmailErrorMessage':
      return !!(errorMessage.email && signupForm.email);
    case 'showConfirmErrorMessage':
      return !!errorMessage.confirmPassword && (signupForm.password !== confirmPassword.value);
    case 'disabledSignup':
      return !(signupForm.email && emailRegex.test(signupForm.email) && signupForm.name && signupForm.nickname && signupForm.password) || signupForm.password !== confirmPassword.value;
    default:
      return false;
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/css/_colors.scss';

.sign_up_box {
  display: flex;
  flex-direction: column;
  height: 100%;

  .sign_up_btn {
    background: $color-debra;
    width: 100%;
    line-height: 25px;
    border-radius: 5px;
    font-size: 10.2px;
    font-weight: bold;
    color: #2a2a2a;
    margin-top: auto;

    &:disabled {
      opacity: 0.3;
    }
  }

  .sign_up_cancel_btn {
    display: flex;
    justify-content: flex-start;
    gap: 5px;
    font-size: 9.3px;
    margin-top: 10px;
    margin-bottom: -13px;

    button {
      display: flex;
      align-items: center;
      font-weight: bold;
      font-size: 10px;

      i {
        font-size: 17px;
      }
    }
  }
}
</style>